'use client';

import classnames from 'classnames';

import { DEFAULT_OPTION } from '@/helpers/constants';
import { useCart } from '@/helpers/shopify/cart';
import { formatCurrency } from '@/helpers/text';

import { Button } from '../button';
import { findCartLineVariant, useCartActions } from '../cart/actions';
import { MaxWidth } from '../max-width';
import { EditItemQuantityButton } from './edit-item-quantity-button';

import './modal.css';

import { format, isValid, parse } from 'date-fns';
import { fr } from 'date-fns/locale';

export const CartModal = () => {
  const [cart, cartActions] = useCart();
  const { removeItem } = useCartActions();

  const closeModal = () => {
    cartActions?.set?.('open', false);
  };

  const handleRemoveFromCartClick = async (line) => {
    const shopifyProduct = line.node.merchandise.product;
    const variant = findCartLineVariant(line);

    await removeItem({
      line,
      shopifyProduct,
      variant,
      quantity: line.node.quantity,
    });
  };

  return (
    <div
      className={classnames('cart__modal', {
        'cart__modal--open': cart.open,
      })}
    >
      <button
        className="cart__modal__overlay"
        aria-label="Fermer panier"
        onClick={closeModal}
      />

      <MaxWidth>
        <div className="cart__modal__wrap">
          <header className="cart__modal__header">
            <div className="cart__modal__header__top">
              <div className="cart__modal__header__title">Mon panier</div>

              <button aria-label="Fermer panier" onClick={closeModal}>
                <img
                  width="18"
                  height="18"
                  src="/static/icons/close-cart-black.svg"
                  alt=""
                />
              </button>
            </div>
          </header>

          {cart.data?.lines?.edges?.length > 0 ? (
            <>
              <div className="cart__modal__list-container">
                <div className="cart__modal__list-wrap">
                  <ul className="cart__modal__list">
                    {cart.data.lines.edges.map((item) => {
                      return (
                        <li className="cart__modal__item" key={item.node.id}>
                          {/* <div>
                      <DeleteItemButton item={item} />
                    </div> */}

                          {item.node.merchandise.image ? (
                            <img
                              className="cart__modal__item__image"
                              src={item.node.merchandise.image.url}
                              width={item.node.merchandise.image.width}
                              height={item.node.merchandise.image.width}
                              alt={
                                item.node.merchandise.image.altText ||
                                item.node.merchandise.product.title
                              }
                            />
                          ) : null}

                          <div className="cart__modal__item__content">
                            <div className="cart__modal__item__top">
                              <div className="cart__modal__item__title">
                                <p className="cart__modal__item__title__name">
                                  {item.node.merchandise.product.title}
                                </p>

                                {item.node.merchandise.selectedOptions
                                  .filter((option) => {
                                    return option.value !== DEFAULT_OPTION;
                                  })
                                  .map((option) => {
                                    const date = parse(
                                      option.value,
                                      'yyyy-MM-dd',
                                      new Date(),
                                    );

                                    const formatted = isValid(date)
                                      ? format(date, 'd MMMM yyyy', {
                                          locale: fr,
                                        })
                                      : option.value;

                                    return (
                                      <p
                                        className="cart__modal__item__title__variation"
                                        key={option.name}
                                      >
                                        {formatted}
                                      </p>
                                    );
                                  })}
                              </div>
                              <button
                                aria-label="Supprimer le produit"
                                onClick={() => handleRemoveFromCartClick(item)}
                              >
                                <img
                                  width="18"
                                  height="18"
                                  src="/static/icons/trash-black.svg"
                                  alt=""
                                />
                              </button>
                            </div>

                            <div className="cart__modal__item__footer">
                              <EditItemQuantityButton
                                line={item}
                                enableInput={false}
                              />

                              <p className="cart__modal__item__footer__total">
                                {formatCurrency(
                                  item.node.cost.totalAmount.amount,
                                  {
                                    currency:
                                      item.node.cost.totalAmount.currencyCode,
                                  },
                                )}
                              </p>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <div className="cart__modal__summerize">
                {/* {cart.data.cost.totalTaxAmount ? (
                  <div>
                    <p>Taxes</p>

                    {formatCurrency(cart.data.cost.totalTaxAmount.amount, {
                      currency: cart.data.cost.totalTaxAmount.currencyCode,
                    })}
                  </div>
                ) : null}

                <div>
                  <p>Frais de livraison</p>
                  <p className="text-right">Calculés au paiement</p>
                </div> */}

                {/* <div className="cart__modal__summerize__sub-total">
                  <div className="cart__modal__summerize__sub-total__row">
                    <p className="bold">Sous-total</p>

                    <p>
                      <span className="light">
                        {count} article{count > 1 ? 's' : ''} |
                      </span>
                      <span className="bold">
                        {formatCurrency(cart.data.cost.totalAmount.amount, {
                          currency: cart.data.cost.totalAmount.currencyCode,
                        })}
                      </span>
                    </p>
                  </div>
                </div> */}

                <div className="cart__modal__summerize__total">
                  <p>Total</p>

                  <p>
                    {formatCurrency(
                      parseInt(cart.data.cost.totalAmount.amount),
                      {
                        currency: cart.data.cost.totalAmount.currencyCode,
                      },
                    )}{' '}
                    TTC
                  </p>
                </div>
              </div>

              <Button
                as="a"
                href={cart.data.checkoutUrl}
                width="full"
                theme="black"
              >
                Valider mon panier
              </Button>
            </>
          ) : (
            <p>Votre panier est vide</p>
          )}
        </div>
      </MaxWidth>
    </div>
  );
};
